
import { computed, defineComponent, onMounted, watch, ref } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import { Actions } from "@/store/enums/StoreEnums";
import moment from "moment";
import Swal from "sweetalert2/dist/sweetalert2.js";
import ApiService from "@/core/services/ApiService";

export default defineComponent({
  name: "kt-vertical-wizard",
  methods: {
    moment(date) {
      return moment(date).format("MMM DD, YYYY");
    },
    getURL(link) {
      //const urlObj = new URL(link);
      //urlObj.protocol = ApiService.getAPI().protocol;
      //urlObj.host = ApiService.getAPI().url + "/";
      //urlObj.port = "";
      //return urlObj.toString();

      // Replace /irb/ with /irb-download/
      const publicPath = link.replace("/irb/", "/irb-download/");

      // Use URL constructor with base URL
      const url = new URL(publicPath, "https://app.irb.gannon.edu");

      return url.toString().replace(/^http:/, "https:");

      // return '/api/'+link;
    },
  },
  components: {},
  props: {
    classification: String,
    title: String,
    hiddeDelete: Boolean,
  },
  setup(props) {
    const store = useStore();
    const route = useRoute();
    const modalNoteType = "Documents";
    const classificationDoc =
      props.classification != null && props.classification != undefined
        ? ref(props.classification)
        : "";
    const hiddeDeleteDocument =
      props.hiddeDelete != null && props.hiddeDelete != undefined
        ? ref(props.hiddeDelete)
        : false;
    const titleTable =
      props.title != null && props.title != undefined && props.title != ""
        ? props.title
        : "Documents";
    const currentDocumentsResponse = computed(() => {
      return store.getters.currentDocumentsResponse;
    });
    const currentIrbReviewer = computed(() => {
      return store.getters.currentIrbReviewer;
    });

    const currentIrbReviewNote = computed(() => {
      return store.getters.currentReviewNoteEdit;
    });

    const currentUser = computed(() => {
      return store.getters.currentUser;
    });

    const currentApplication = computed(() => {
      return store.getters.currentApplication !== null
        ? store.getters.currentApplication.data
        : {};
    });

    const IsIrbChair = computed(() => {
      if (currentUser.value?.userRoles?.indexOf("irbchair") !== -1) {
        return "Yes";
      }
      return "No";
    });

    const IsIrbMember = computed(() => {
      if (currentUser.value?.userRoles?.indexOf("irbmember") !== -1) {
        return "Yes";
      }
      return "No";
    });

    onMounted(() => {
      store.dispatch(Actions.GET_IRB_DOCUMENTS, [
        route.params.id,
        classificationDoc,
      ]);

      setCurrentPageBreadcrumbs("Vertical", ["Pages", "Wizards"]);
    });

    const downloadFile = (file) => {
      var binaryString = window.atob(file.data);
      var binaryLen = binaryString.length;
      var bytes = new Uint8Array(binaryLen);
      for (var i = 0; i < binaryLen; i++) {
        var ascii = binaryString.charCodeAt(i);
        bytes[i] = ascii;
      }

      var blob = new Blob([bytes], { type: file.type });
      var link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      var fileName = file.name;
      link.download = fileName;
      link.click();
    };

    const deleteFile = (appId, id, name, classificationDoc) => {
      const data = {
        appId: appId,
        id: id,
        name: name,
        classification: classificationDoc,
      };
      Swal.fire({
        html: `Are you sure to delete the uploaded<br/> <b>"${data.name}"</b>" file?`,
        icon: "warning",
        buttonsStyling: false,
        showCancelButton: true,
        confirmButtonText: "Delete it!",
        cancelButtonText: "Cancel",
        customClass: {
          confirmButton: "btn btn-danger",
          cancelButton: "btn btn-light",
        },
      }).then((result) => {
        if (result.isConfirmed) {
          store
            .dispatch(Actions.DELETE_IRB_DOCUMENTS, data)
            .then(() => {
              Swal.fire({
                text: "File was deleted!",
                icon: "success",
                buttonsStyling: false,
                confirmButtonText: "Ok",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
              }).then(() => {
                console.log("");
              });
            })
            .catch(() => {
              Swal.fire({
                text: store.getters.currentDocumentResponse.message,
                icon: "error",
                buttonsStyling: false,
                confirmButtonText: "Ok, got it!",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
              });
            });
        }
      });
    };

    watch(
      () => route.params.id,
      async () => {
        await store.dispatch(Actions.GET_IRB_DOCUMENTS, [
          route.params.id,
          classificationDoc,
        ]);
      }
    );

    return {
      currentDocumentsResponse,
      currentIrbReviewNote,
      currentIrbReviewer,
      currentUser,
      IsIrbMember,
      currentApplication,
      IsIrbChair,
      deleteFile,
      downloadFile,
      classificationDoc,
      titleTable,
      hiddeDeleteDocument,
    };
  },
});
